import React from "react";
import PropTypes from "prop-types";
import { Button } from "@vitalsource/vstui";

class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: this.props.top,
      height: this.props.height
    };

    this._closePanelEvent = this._closePanelEvent.bind(this);
  }

  _closePanelEvent() {
    this.props.closePanelCallback(this.props.identifier, this.props.keyobj);
  }

  renderFullScreen() {
    if (this.props.fullscreen) {
      return <div className="panel-button fullscreen-panel" />;
    }
  }

  render() {
    const {
      top,
      height,
      content,
      progress,
      title,
      titleContent,
      side,
      keyobj,
      width,
      hidden,
      hideHeader,
      dataUID,
      panelEvents
    } = this.props;

    const progressStyle = { width: progress + "%" };
    const divStyle = {
      top: top,
      height: height,
      width: width ? width + "px" : "100%"
    };
    if (hidden) {
      divStyle.display = "none";
    }
    const hideHeaderClass = hideHeader ? " hide-header" : "";

    return (
      <div
        key={"panel-uid-" + dataUID}
        data-uid={dataUID}
        style={divStyle}
        aria-hidden={hidden ? "true" : "false"}
        className={content.key + "-container panel " + side}
      >
        {!hideHeader && (
          <div className="header noselect">
            <h2
              id={"panel-header-" + keyobj.key}
              className={
                "panel-title no-highlight " +
                (typeof title === "object" ? "has-content" : "") +
                hideHeaderClass
              }
              tabIndex={-1}
            >
              {titleContent || title || keyobj.key}
            </h2>
            {this.renderFullScreen()}
            <Button
              className="panel-close-button"
              onClick={this._closePanelEvent}
              naked
            >
              <span>
                {i18n.t("reader.panels.close-panel", { panelName: keyobj.key })}
              </span>
            </Button>
          </div>
        )}

        <div className={"content " + hideHeaderClass}>{content}</div>
      </div>
    );
  }
}

Panel.propTypes = {
  fullscreen: PropTypes.bool,
  hideHeader: PropTypes.bool,
  hidden: PropTypes.bool,
  skipBorders: PropTypes.bool,
  side: PropTypes.string,
  titleContent: PropTypes.any, // types ??
  identifier: PropTypes.any, // types ??
  dataUID: PropTypes.number,
  dataIndex: PropTypes.number,
  progress: PropTypes.number,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  closePanelCallback: PropTypes.func,
  content: PropTypes.object, // shape?
  keyobj: PropTypes.object, // shape?
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object // shape?
  ]),
  panelEvents: PropTypes.shape({
    startDragEvent: PropTypes.func,
    stopDragEvent: PropTypes.func,
    startDragBorder: PropTypes.func,
    startSlideHandle: PropTypes.func,
    toggleMinimize: PropTypes.func
  })
};

Panel.defaultProps = {
  title: "",
  fullscreen: false,
  hideHeader: false,
  hidden: false,
  skipBorders: false,
  side: "left",
  progress: 0
};

module.exports = Panel;
